// ====================================================================
// Agent Ask Bar — fixed bottom launcher
// --------------------------------------------------------------------
// Replaces the floating bubble on pages where it's enabled. It does NOT
// run its own conversation: typing a question (or clicking a starter
// prompt) dispatches a `hahn-agent:ask` event that the drawer
// (assets/js/site/agent-mode.js) listens for — it opens the drawer and
// submits the question. The hover/focus chip reveal is pure CSS.
// ====================================================================

(function () {
  var bar = document.querySelector('[data-agent-bar]');
  if (!bar) return;

  var form  = bar.querySelector('[data-agent-bar-form]');
  var input = bar.querySelector('[data-agent-bar-input]');
  var chips = bar.querySelectorAll('[data-agent-bar-chip]');

  // Hand a question off to the drawer. Empty message just opens the drawer.
  function ask(message) {
    document.dispatchEvent(new CustomEvent('hahn-agent:ask', {
      detail: { message: message || '' }
    }));
  }

  if (form && input) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = input.value.trim();
      input.value = '';
      ask(msg);
    });
  }

  Array.prototype.forEach.call(chips, function (chip) {
    chip.addEventListener('click', function (e) {
      e.preventDefault();
      var text = chip.getAttribute('data-prompt') || chip.textContent.trim();
      if (text) ask(text);
    });
  });
})();
